import {useMemo} from "react";

import {UserOrganization} from "../model/types";
import {filterUsers} from "../model/filterUsers";
import {sortUsers} from "../model/sortUsers";

type UseUserListViewProps = {
  users: UserOrganization[];
  searchTerm: string;
  sortColumn: string;
  sortOrder: "asc" | "desc";
};

export const useUserListView = ({
  users,
  searchTerm,
  sortColumn,
  sortOrder,
}: UseUserListViewProps) => {
  const filteredUsers = useMemo(() => {
    return filterUsers({users, searchTerm});
  }, [users, searchTerm]);

  const sortedUsers = useMemo(() => {
    return sortUsers({users: filteredUsers, sortColumn, sortOrder});
  }, [filteredUsers, sortColumn, sortOrder]);

  return {
    filteredUsers,
    sortedUsers,
  };
};
